<template>
  <v-card class="mt-n5" elevation="0">
    
    <v-card elevation="2" class="my-4 mx-4">
      <!-- <v-row > -->
        <v-col cols="12" class="py-2 mb-0 pt-0">
          <div class="mx-4 py-3" style="background-color: #FFFFFF">

          <v-dialog
              v-model="dialogObsRel"
              max-width="900px"
              persistent
            >
            <v-card class="mx-0">
              <v-form ref="form" v-model="valid" lazy-validation>
              <v-toolbar
                color="#286090"
                dark
              >
                <img src="@/assets/logo_nuevo.png" style="width:50px;height:51px" class="mr-4">
                <h2>OBSERVACIONES RELATOR</h2>
                <v-spacer></v-spacer>
                  <v-btn
                    icon
                    @click="dialogObsRel = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
              </v-toolbar>
                <v-container class="mt-9" v-if="role == 'relator'">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      class="mt-n6"
                    >
                    <vue-editor
                      v-model="observaciones_rel_edit"
                      outlined
                      name="input-7-4"
                      placeholder=""
                      required
                    ></vue-editor>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn
                      class="mb-2"
                      color="grey darken-1"
                      text
                      @click="close()"
                    >
                      Cerrar
                    </v-btn>
                    <v-btn
                      class="mb-2"
                      color="#1D2E4B"
                      text
                      :loading="loading"
                      :disabled="!valid"
                      @click="validate"
                    >
                      GUARDAR
                    </v-btn>
                </v-card-actions>
                </v-container>
               
                </v-form>
              </v-card>
            </v-dialog>
              <!-- observaciones relator -->
              <div class="mt-2"
                v-if="(role == 'relator') || role == 'magistrado'"
              >
                <div>
                  <p class="text-h6 grey--text"> OBSERVACIONES RELATOR</p>
                </div>

                <v-card
                    v-if="(role == 'relator' || role == 'magistrado') && observaciones"
                    v-scroll.self="onScroll"
                    class="overflow-y-auto mt-3 mb-4"
                    max-height="900"
                    min-height="150"
                    style="background-color: #FFFFFF"
                    
                  >
                    <v-card-text >
                      <div
                        class="mb-4"
                        v-html="observaciones"
                      >
                      </div>
                    </v-card-text>

                  </v-card>
                  <br>
                <!-- <div class="mt-4 mb-4" style="color: black;" v-html="observaciones"></div> -->
                <v-alert
                  v-if="!observaciones"
                  border="bottom"
                  dense
                  elevation="2"
                  outlined
                  type="info"
                >NO SE HAN AGREGADO OBSERVACIONES DEL RELATOR</v-alert>
              </div>
              <div class="text-center mb-6 mt-n7">
                <v-btn
                v-if="role == 'relator' && item.status <= 42"
                class="mt-6 mb-n3"
                dense
                small
                dark
                outlined
                color="teal"
                @click="dialogObsRel = true; observaciones_rel_edit = observaciones"
              >
                <v-icon >
                  mdi-pencil-plus
                </v-icon>
                 Observación Relator
              </v-btn>
              </div>
              <v-divider></v-divider>
            <!-- observaciones magistrado -->
              <div class="mt-10"
                v-if="role == 'magistrado' || role == 'relator'"
              >
                <div>
                 <p class="text-h6 grey--text"> OBSERVACIONES MAGISTRADO</p>
                </div>
                  <v-card
                    v-scroll.self="onScroll"
                    class="overflow-y-auto mt-3 mb-2"
                    max-height="600"
                    min-height="150"
                    v-if="(role == 'magistrado' || role == 'relator') && observaciones_mag">

                    <v-card-text>
                      <div
                        class="mb-4"
                        v-html="observaciones_mag"
                      >
                      </div>
                    </v-card-text>

                  </v-card>
                  <br>
                <!-- <div class="mt-7 mb-7" style="color: black;" v-html="observaciones_mag"></div> -->
                <v-alert
                  v-if="!observaciones_mag"
                  border="bottom"
                  dense
                  elevation="2"
                  outlined
                  type="info"
                >NO SE HAN AGREGADO OBSERVACIONES</v-alert>
              </div>
             
              <v-row v-if="(role == 'relator' || role == 'magistrado') && (item.status > 41 && item.status < 44)">
                  <v-col cols="12" md="6" class="mt-n5">
                    <v-card
                      v-if="item.sentido_ponencia"
                      class="mx-auto"
                      width="600"
                      prepend-icon="mdi-home"
                    >
                      <v-card-text>
                        <b>Sentido Ponencia: </b>
                        {{item.sentido_ponencia}}
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6" class="mt-n5">
                    <v-card
                    v-if="fecha_cuenta"
                      class="mx-auto"
                      width="600"
                      prepend-icon="mdi-home"
                    >
                      <v-card-text>
                        <b>Fecha Cuenta: </b>
                        {{fecha_cuenta}}
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <br>
              <v-spacer></v-spacer>
              <v-row
              align="center"
              justify="space-around"
              >

              <v-btn
              v-if="role == 'magistrado' && item.status <= 42"
                class="mt-2"
                dense
                small
                dark
                outlined
                color="teal"
                @click="dialogMagistrado()"

              >
                <v-icon>
                  mdi-pencil-plus
                </v-icon>
                Observación Magistrado
              </v-btn>
              </v-row>
               
              <v-dialog
                v-model="dialogObsMag"
                max-width="900px"
                persistent
              >

        <!-- <v-row max-width="600px" justify="center"> -->
          <v-card elevation="3" class="mx-0">

              <v-form ref="form" v-model="validObservacion" lazy-validation>
                <v-toolbar
                color="#286090"
                dark
              >
                <img src="@/assets/logo_nuevo.png" style="width:50px;height:51px" class="mr-4">
                <h2>OBSERVACIONES MAGISTRADO</h2>
                <v-spacer></v-spacer>
                  <v-btn
                    icon
                    @click="close()"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
              </v-toolbar>

                <v-container class="mt-5" >
                <!-- <v-container class="mt-5"  v-if="role == 'magistrado' && item.status <= 42"> -->

                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      class="mt-n5"
                    >
                    <vue-editor
                      v-model="observaciones_mag_edit"
                      outlined
                      name="input-7-4"
                      placeholder=""
                      required
                    ></vue-editor>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="">
                      <!-- :item-text=" item => item.nombre + ' (' + item.magistrado.nombre + ' ' + item.magistrado.primer_apellido + ')' " -->
                      <v-autocomplete
                        outlined
                        label="Sentido"
                        persistent-hint
                        :items = "getAllSentidos"
                        item-value="id"
                        item-text="nombre"
                        v-model="sentido_id_edit"
                        required
                        :rules="[rules.requiredSelect]"
                      />
                    </v-col>
                    <v-col cols="12" md="6" class="">
                      <v-menu
                        v-model="menu_fecha_cuenta"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="fecha_cuenta_edit"
                            label="Fecha de Cuenta"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                            :rules="[rules.required]"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fecha_cuenta_edit"
                          @input="menu_fecha_cuenta= false"
                          locale="es-mx"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn
                      class="mb-2"
                      color="grey darken-1"
                      text
                      @click="close()"
                    >
                      Cerrar
                    </v-btn>
                    <v-btn
                      class="mb-2"
                      color="#1D2E4B"
                      text
                      :loading="loading"
                      :disabled="!validObservacion"
                      @click="validate"
                    >
                      GUARDAR
                    </v-btn>
                </v-card-actions>

              
              </v-container>
            </v-form>

    </v-card>
  <!-- </v-row> -->

  </v-dialog>
  
<br>
          </div>
        </v-col>
      <!-- </v-row> -->
    </v-card>
  </v-card>

</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import { VueEditor } from 'vue2-editor';
import BaseSelect from "@/components/BaseSelect.vue";
import Autocomplete from "@/components/Autocomplete";

export default {
props: {
  item: {
    type: Object,
    required: true
  },
  role: {
    type: String,
    required: true
  }
},
components: { BaseSelect, Autocomplete },
data: () => ({
  toca:'',
  observaciones:'',
  observaciones_mag:'',
  observaciones_rel_edit:'',
  observaciones_mag_edit:'',
  menu_fecha_cuenta:false,
  fecha_cuenta:'',
  sentido_id:'',
  fecha_cuenta_edit:'',
  sentido_id_edit:'',
  loadingData: true,
  checkedToca: false,
  disabledJuzgado: true,
  // disabledMunicipio: true,
  disabled: true,
  dialog:false,
  dialogObsMag:false,
  dialogObsRel:false,
  menu_fecha_recepcion: false,
  menu_fecha_citacion: false,
  menu_fecha_turno: false,

  municipio_id:'', //municipio_id =>para filtrar los juzgados por municipio_id
  materia_id:'', //Civil o Mercantil este es para filtrar el tipo de juciio y traernos as las vias y demas
  reconvencion:null,  //el objeto seleccionado de la reconvencion
  has_reconvencion:false,   //para comportamiento de mostrar o deshabilitar el campo reconvencion
  tipo_registro:'',  //para comportamiento de mostrar ponencias y sirve para registrar un amparo

  ponencia_selected:'',
  valid: false,
  validObservacion: false,
  loading: false,
  scrollInvoked: 0,
  cuenta:'',
  // toca: "",
  expediente: "",
  oficio: "",
  juzgado_id: "",
  actor: "",
  demandado: "",
  materia_apelacion: "",
  via_id: "",
  accion_id: "",
  fecha_recepcion: "",
  fecha_citacion: "",
  fecha_turno: "",
  rules: {
    required:v => !!v.trim() || 'Campo requerido',
    requiredSelect:v => !!v|| 'Campo requerido'
  }
}),
created() {
  // this.$store.commit("SET_LAYOUT", "dashboard-layout");
  // this.getCuenta()
},
mounted(){
  this.cuenta = this.item
  if (this.cuenta.observaciones) {
    this.observaciones = this.cuenta.observaciones
  }
  if (this.cuenta.observaciones_mag) {
    this.observaciones_mag = this.cuenta.observaciones_mag
  }
  if (this.cuenta.sentido_ponencia_id) {
    this.sentido_id = this.cuenta.sentido_ponencia_id
  }
  if (this.cuenta.fecha_cuenta) {
    this.fecha_cuenta = this.cuenta.fecha_cuenta
  }
},
destroyed() {
  // console.log("Componente eliminado"); se destruye con el v-if del papa
},
computed: {
  showApelacion(){
  },
  ...mapGetters([
    "currentUser",
    "roleUser",
  ]),
},
created() {
  this.$store.dispatch("GET_ALL_SENTIDOS", { url: "/sentidos" });
},
computed: {
  ...mapGetters(["getAllSentidos","roleUser"])
},
methods:{
  onScroll () {
    this.scrollInvoked++
  },
  validate() {
    if (this.$refs.form.validate()) {
        var tocacompleto = this.toca.replace('/','');
        this.anio = tocacompleto.substr(tocacompleto.length - 4);
        this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
        this.loading = true;
        if (this.roleUser == 'relator' && !this.observaciones_rel_edit) {
          this.$swal({
            title: "Error",
            text: "Favor de agregar una observación",
            icon: "warning",
            confirmButtonText: "Aceptar"
          });
          this.loading = false;
        }
        else if (this.roleUser == 'magistrado' && !this.observaciones_mag_edit) {
          this.$swal({
            title: "Error",
            text: "Favor de agregar una observación",
            icon: "warning",
            confirmButtonText: "Aceptar"
          });
          this.loading = false;
        }
        else {
          this.save();
        }
    }
  },
  save() {
    var observacion = {
      cuenta_id:this.item.id,
      observaciones: this.observaciones_rel_edit,
      observaciones_mag: this.observaciones_mag_edit,
      sentido_ponencia_id: this.sentido_id_edit,
      fecha_cuenta: this.fecha_cuenta_edit,
    }
    var url;
    if (this.roleUser == 'relator') {
      url = '/cuenta/'+this.item.id+'/observaciones';
    } else if (this.roleUser == 'magistrado') {
      url = '/cuenta/'+this.item.id+'/sentido';
    }
    // console.log(url);
    this.$store.dispatch("CREATE_OBSERVACION", { url: url, data:observacion })
    .then(response => {
        this.loading = false;
        if (response.data.status == "ok") {
          this.$swal({
            title: "Éxito!!!",
            text: "El toca ha sido actualizado correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar"
          });

          this.observaciones = response.data.data.cuenta.observaciones
          this.observaciones_mag = response.data.data.cuenta.observaciones_mag
          this.item.sentido_ponencia = response.data.data.cuenta.sentido_ponencia
          this.sentido_id = parseInt(response.data.data.cuenta.sentido_ponencia_id)
          this.fecha_cuenta = response.data.data.cuenta.fecha_cuenta
        }
        // this.showCuenta()
        this.resetValidation()
        this.close()

      }).catch(error => {
        console.log(error);
        this.loading = false;
        this.$swal({
          title: "Error",
          text: "No se pudo guardar",
          icon: "error",
          confirmButtonText: "Aceptar"
        });
      });
  },
  resetValidation () {
    this.$emit('closeModal');
    this.dialog = false
    this.$refs.form.resetValidation()
    this.numero=""
    this.anio=""
    this.expediente=""
    this.oficio=""
    this.juzgado_id=""
    this.actor=""
    this.demandado=""
    this.materia_apelacion=""
    this.via_id=""
    this.accion_id=""
    this.fecha_recepcion=""
    this.fecha_citacion=""
    this.fecha_turno= ""
    this.has_reconvencion=""
    this.municipio_id=""
    this.tipo_registro=""
    this.materia_id=""
  },
  close () {
  this.dialogObsMag = false
  this.dialogObsRel = false
  // this.$nextTick(() => {
    // this.editedIndex = -1
    this.resetValidation()
    // this.$refs.form.reset()
    // this.editedItem = Object.assign({}, this.defaultItem)

    //this.observaciones = ''
    // this.$emit('close', false);
  // })
},
dialogMagistrado() {
  this.dialogObsMag = true,
  this.observaciones_mag_edit = this.observaciones_mag,
  this.sentido_id_edit = this.sentido_id,
  this.fecha_cuenta_edit = this.fecha_cuenta

},
}
};
</script>
